import resolveCachedImageURL from 'src/lib/sync-box/image-cache/utils/resolveCachedImageURL';
import Image from './Image';
class CachedImage extends Image {
    static blotName = 'cachedImage';
    static create(value) {
        const node = Image.create(value);
        resolveCachedImageURL(node.src).then(cachedSrc => {
            node.src = cachedSrc;
        });
        return node;
    }
}
export default CachedImage;
